import { Injectable } from '@angular/core';
import { HttpRequest,  HttpHandler,  HttpEvent,  HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { TokenStorageService } from '../services/token-storage.service';
import { SharedService } from '../services/shared.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private tokenStorageService: TokenStorageService, 
    private sharedService: SharedService    
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<Object>> {
    if (request.url.includes('/disbursement-session/cv') || request.url.includes('/brand-profile')) {
      return next.handle(request);
    }
    let authReq = request;
    let authToken = this.tokenStorageService.getAuthToken();
    if (authToken != null) {
      authReq = this.addTokenHeader(request, authToken);
    }
    return next.handle(authReq)
    .pipe(
      catchError(this.sharedService.handleError)
    );

  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
  }  

}
